import type {
  DataSourceConfig,
  DataSourceId,
} from '../types/dataSource'

export const defaultDataSourceConfigs: DataSourceConfig[] = [
  {
    id: 'polymarket',
    name: 'Polymarket',
    description: '全球事件市场，默认使用最近一次成功同步的公开数据，无需配置即可使用。',
    enabled: true,
    status: 'default',
    requiresCredentials: false,
    supportsAdvancedConfig: true,
  },
  {
    id: 'kalshi',
    name: 'Kalshi',
    description: '受监管的事件市场，默认使用最近一次同步的公开数据。',
    enabled: true,
    status: 'default',
    requiresCredentials: false,
    supportsAdvancedConfig: true,
  },
  {
    id: 'cme-fedwatch',
    name: 'CME FedWatch',
    description: '美联储利率预期工具，本轮仅预留连接入口。',
    enabled: false,
    status: 'not-configured',
    requiresCredentials: true,
    supportsAdvancedConfig: true,
  },
]

export function getDataSourceConfig(id: DataSourceId) {
  return defaultDataSourceConfigs.find((source) => source.id === id)
}
